// Catálogo de clientes (aeropuertos) de tkelevator: código IATA + nombre.
// Alimenta el selector "Cliente" de S02 (Datos de contrato); el valor guardado
// es "CÓDIGO - Nombre" para que sea inequívoco (p. ej. VIL y VNO son ambos Vilnius)
// y se muestre igual en el Resumen (S01), que lo lee en solo lectura.
export const CLIENT_AIRPORTS = [
  { code: 'ADB', name: 'Izmir' },
  { code: 'ALA', name: 'Almaty' },
  { code: 'ARG', name: 'Argentina 2000' },
  { code: 'ATH', name: 'Atenas' },
  { code: 'BCN', name: 'Barcelona' },
  { code: 'BER', name: 'Berlín' },
  { code: 'BIO', name: 'Biarritz' },
  { code: 'BJV', name: 'Bodrum' },
  { code: 'BUD', name: 'Budapest' },
  { code: 'CAG', name: 'Cagliari' },
  { code: 'CGN', name: 'Colonia' },
  { code: 'CPH', name: 'Copenhague' },
  { code: 'CRA', name: 'Craiova' },
  { code: 'CTB', name: 'Catumbela' },
  { code: 'DFW', name: 'Dallas FW' },
  { code: 'EDI', name: 'Edimburgo' },
  { code: 'ESB', name: 'Ankara' },
  { code: 'FMO', name: 'Münster' },
  { code: 'FRA', name: 'Frankfurt' },
  { code: 'GLA', name: 'Glasgow' },
  { code: 'GVA', name: 'Ginebra' },
  { code: 'HEL', name: 'Helsinki' },
  { code: 'KEF', name: 'Keflavík' },
  { code: 'KSN', name: 'Kostanay' },
  { code: 'LCA', name: 'Larnaca' },
  { code: 'LGW', name: 'Gatwick' },
  { code: 'LHR', name: 'Heathrow' },
  { code: 'LIM', name: 'Lima' },
  { code: 'LIS', name: 'Lisboa' },
  { code: 'LUX', name: 'Luxemburgo' },
  { code: 'MAD', name: 'Madrid' },
  { code: 'MRS', name: 'Marsella' },
  { code: 'MXM', name: 'Malmö' },
  { code: 'NCL', name: 'Newcastle' },
  { code: 'ORD', name: "O'Hare Chicago" },
  { code: 'ORK', name: 'Cork' },
  { code: 'ORN', name: 'Orán' },
  { code: 'OSL', name: 'Oslo' },
  { code: 'OTP', name: 'Bucarest' },
  { code: 'PMO', name: 'Palermo' },
  { code: 'POA', name: 'Porto Alegre' },
  { code: 'PTP', name: 'Guadalupe' },
  { code: 'PUJ', name: 'Punta Cana' },
  { code: 'PVD', name: 'Rhode Island' },
  { code: 'RHD', name: 'Río Hondo' },
  { code: 'ROS', name: 'Rosario' },
  { code: 'SAL', name: 'El Salvador' },
  { code: 'SJO', name: 'San José' },
  { code: 'SKD', name: 'Samarkanda' },
  { code: 'SKP', name: 'Skopie' },
  { code: 'SRE', name: 'Sucre' },
  { code: 'SSA', name: 'Salvador de Bahía' },
  { code: 'STR', name: 'Stuttgart' },
  { code: 'SVG', name: 'Stavanger' },
  { code: 'SWZ', name: 'Alat' },
  { code: 'TAS', name: 'Taskent' },
  { code: 'TLL', name: 'Tallin' },
  { code: 'TLS', name: 'Toulouse' },
  { code: 'URC', name: 'Urumqi' },
  { code: 'UVF', name: 'Santa Lucía' },
  { code: 'VCE', name: 'Venecia' },
  { code: 'VGO', name: 'Vigo' },
  { code: 'VIE', name: 'Viena' },
  { code: 'VIL', name: 'Vilnius' },
  { code: 'VNO', name: 'Vilnius' },
  { code: 'WAW', name: 'Varsovia' },
  { code: 'WPG', name: 'Winnipeg' },
  { code: 'YHM', name: 'Hamilton' },
  { code: 'ZAL', name: 'Pichoy' },
]

// Opciones para el selector: valor = etiqueta = "CÓDIGO - Nombre".
export function clientAirportOptions () {
  return CLIENT_AIRPORTS.map((a) => {
    const label = a.code + ' - ' + a.name
    return { value: label, label }
  })
}

// Opciones para los códigos (Documentación/Correspondencia): valor = código IATA, etiqueta legible.
// El código es lo que entra en el "código completo" (p. ej. ATH en ...-TKAS-ATH-...).
export function clientCodeOptions () {
  return CLIENT_AIRPORTS.map((a) => ({ value: a.code, label: a.code + ' - ' + a.name }))
}
